export class BitBuffer {
    buffer;
    length;
    constructor() {
        this.buffer = [];
        this.length = 0;
    }
    getBuffer() {
        return this.buffer;
    }
    getLengthInBits() {
        return this.length;
    }
    toString() {
        let buffer = '';
        for (let i = 0; i < this.getLengthInBits(); i += 1) {
            buffer += this.getBit(i) ? '1' : '0';
        }
        return buffer;
    }
    getBit(index) {
        return ((this.buffer[~~(index / 8)] >>> (7 - (index % 8))) & 1) == 1;
    }
    put(num, length) {
        for (let i = 0; i < length; i += 1) {
            this.putBit(((num >>> (length - i - 1)) & 1) == 1);
        }
    }
    putBit(bit) {
        if (this.length == this.buffer.length * 8) {
            this.buffer.push(0);
        }
        if (bit) {
            this.buffer[~~(this.length / 8)] |= 0x80 >>> this.length % 8;
        }
        this.length += 1;
    }
}
//# sourceMappingURL=BitBuffer.js.map